import React from 'react';
import useOnboardingSummary from '../../../../hooks/useOnboardingSummary';
import type { OnboardingSummary } from '../../../../types/onboarding';
import Shield from '../../../../assets/images/shield.svg';
import Dollar from '../../../../assets/images/coin.svg';
import Crown from '../../../../assets/images/crown-circle.svg';
import Bar from '../../../../assets/images/bar.svg';

interface SectionOneProps {
  section: OnboardingSummary;
}

const SectionOne = ({ section }: SectionOneProps) => {
  const { fundingStage, targetCheckSize, keyMetrics } = useOnboardingSummary({
    section,
  });

  return (
    <div>
      <div className='font-bold text-body-400 mb-4 flex items-center gap-2 mt-6'>
        <img
          className='w-6 h-6 object-contain'
          src={Shield}
          alt='Primary Goal'
        />
        Primary Goal:
      </div>
      <div className='text-lg mb-6'>Raising capital for my start up</div>
      <div className='grid grid-cols-2 md:grid-cols-4 gap-2'>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img className='w-6 h-6 object-contain' src={Dollar} alt='Dollar' />{' '}
            Funding stage:
          </div>
          <div className='text-lg leading-[1.5rem] text-green-700 font-medium font-heading'>
            {fundingStage}
          </div>
        </div>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img className='w-6 h-6 object-contain' src={Crown} alt='Crown' />{' '}
            Target check size:
          </div>
          <div className='text-2xl text-green-700 font-medium font-heading'>
            {targetCheckSize}
          </div>
        </div>
        <div className='bg-white w-full p-6 rounded-xl col-span-2'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img className='w-6 h-6 object-contain' src={Bar} alt='Bar' /> Key
            metrics:
          </div>
          <div className='font-medium'>{keyMetrics}</div>
        </div>
      </div>
    </div>
  );
};

export default SectionOne;
